"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["Info"] = 0] = "Info";
    NotificationType[NotificationType["Danger"] = 1] = "Danger";
    NotificationType[NotificationType["Warning"] = 2] = "Warning";
    NotificationType[NotificationType["Success"] = 3] = "Success";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
//# sourceMappingURL=NotificationType.js.map